export default "__VITE_ASSET__BVSJ7bLp__"